import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  bomListApi,
  bomGetByItemApi,
  bomSaveApi,
  bomDeleteApi,
} from "../../../apiservice/bom";

export const fetchBomList = createAsyncThunk(
  "bom/fetchList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await bomListApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchBomByItem = createAsyncThunk(
  "bom/fetchByItem",
  async (item_id, { rejectWithValue }) => {
    try {
      const res = await bomGetByItemApi(item_id);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const saveBom = createAsyncThunk(
  "bom/save",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await bomSaveApi(payload);
      if (res.data?.error) {
        return rejectWithValue(res.data);
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteBom = createAsyncThunk(
  "bom/delete",
  async (bom_id, { rejectWithValue }) => {
    try {
      const res = await bomDeleteApi(bom_id);
      return { bom_id, ...res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
